/** Multiplier to convert 0–1 export progress to a CSS percentage width. */
export const EXPORT_PROGRESS_PERCENT_SCALE = 100;
/** Decimal places shown in the export progress label. */
export const EXPORT_PROGRESS_DECIMAL_PLACES = 0;
/** Max wait before failing an export stuck in an unknown state (not GENERATING/COMPLETED/FAILED). */
export const EXPORT_UNRECOGNIZED_STATE_TIMEOUT_MS = 60_000;
/** Delay before opening the downloaded file after COMPLETED, giving the dialog time to close first. */
export const EXPORT_COMPLETION_OPEN_DELAY_MS = 1_000;
/** Interval between export status poll requests while state is GENERATING. */
export const EXPORT_POLL_INTERVAL_MS = 1_000;
